/**
 * File created by suenlue on 13.02.21.
 * Copyright (c) 2021 by netTrek GmbH & Co. KG
 */
import { InjectionToken } from '@angular/core';

export const ERROR_FEEDBACK_MAIL: InjectionToken<string> =
               new InjectionToken<string> ( 'mail address that receive errors' );

export const ERROR_IGNORE_URLS: InjectionToken<string[]> =
               new InjectionToken<string> ( 'URLs that will be ignore from Error Interceptor' );

